import botReducer from "./bot";
import { combineReducers } from "redux";

const allReducers = combineReducers({
    botReducer
})

export default allReducers;